import React from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';

// css
import './SobrePage.css'; // Seu CSS customizado
import 'bootstrap/dist/css/bootstrap.min.css';  // Importando o CSS do Bootstrap
// import '../../styles/global.css';

const SobrePage = () => {
  

  return (
    <div className="sobre-mostrar-dados-container">
      <TituloComponent />
  
      <div className="sobre-content">
        <div className="sobre-box-dados">
          <h1 className="titulo-sobre">Sobre o Sistema</h1>
  
          <p className="paragrafo-sobre">
            Nosso sistema foi pensado para oferecer uma experiência moderna, 
            prática e inteligente em restaurantes e bares em geral, eliminando a necessidade 
            de interação direta com garçons para fazer pedidos e possibilitando o acompanhamento
            do status do pedido: se ainda está em preparação, se já está liberado para o garçom
            ou se já foi entregue.
          </p>
  
          <h2 className="subtitulo-sobre">Como funciona para o cliente:</h2>
          <ul className="lista-sobre">
            <li>Visualize restaurantes próximos a você com base na geolocalização.</li>
            <li>Escolha o restaurante desejado e faça check-in.</li>
            <li>Acesse o cardápio digital, informe seus dados e tenha as seguintes opções:</li>
            <ul className="sublista-sobre">
              <li>Fazer pedidos para a mesa.</li>
              <li>Solicitar fichas de consumo.</li>
              <li>Acompanhar o status dos pedidos: se está em preparação no bar, na cozinha ou se já está liberado para o garçom.</li>
              <li>Pagar suas fichas e deixá-las prontas para uso, usando cartão salvo 
                  ou informando seus dados no PagBank.</li>
              <li>Pagar apenas pelos seus pedidos ou por todos os pedidos feitos na mesa, 
                  também usando cartão salvo ou informando seus dados no PagBank.</li>
              <li>Ver histórico dos pedidos entregues na sua mesa e das suas fichas já utilizadas.</li>
            </ul>
          </ul>
  
          <h2 className="subtitulo-sobre">Funcionalidades para o gerente:</h2>
          <ul className="lista-sobre">
            <li>Cadastrar o estabelecimento com localização em tempo real.</li>
            <li>Cadastrar funcionários do bar, cozinha e garçons.</li>
            <li>Gerenciar cardápio com produtos próprios ou importados da lista pré-cadastrada.</li>
            <li>Gerar QRCode para suas mesas, para que seus clientes ao fazer o checkin, consigam atualizar os dados.</li>
            <li>Visualizar o andamento das mesas e comandas abertas.</li>
          </ul>
  
          <h2 className="subtitulo-sobre">Para os funcionários:</h2>
          <ul className="lista-sobre">
            <li><strong>Bar e Cozinha:</strong> recebem e liberam pedidos para o garçom.</li>
            <li><strong>Garçom:</strong> recebe a liberação do bar ou da cozinha e finaliza os pedidos, após entregá-los na mesa.</li>
          </ul>
  
          <p className="paragrafo-sobre">
            Com esse sistema, o atendimento se torna mais ágil, organizado e independente, 
            melhorando a experiência tanto para o cliente quanto para os funcionários do restaurante.
          </p>
        </div>
      </div>
    </div>
  );
  

};

export default SobrePage;
